import * as Actions from './actionTypes';
import defaultHeaderOptions from '../shared/defaultHeaderOptions';
import * as APIUtils from '../shared/apiUtils';
import { checkIfQuestionsAreValid, generateJsonFromSurveyResponses } from './utils';
import { isLocalStorageSupported } from '../shared/dataUtils';
import { find } from 'lodash';

export function submitSurvey(eventId, surveyId, accountId) {
  return (dispatch, getState) => {
    const currentPagePosition = getState().currentPage;
    const surveyResponses = getState().surveyResponses;
    // first check if current page is valid
    let currentSurveyResponse = find(surveyResponses, { 'surveyPagePosition': currentPagePosition });
    let currentPageValid = checkIfQuestionsAreValid(currentSurveyResponse.questionResponses);

    if(!currentPageValid) {
      return dispatch(currentPageNotValid());
    } else {
      dispatch(submitSurveyBegin());
      let url = `/api/public/events/${eventId}/surveys/${surveyId}/survey_responses`;
      return fetch(url, {
          method: 'POST',
          body: generateJsonFromSurveyResponses(surveyResponses, accountId),
          headers: defaultHeaderOptions
        }).then(APIUtils.checkStatus)
        .then(APIUtils.parseJSON)
        .then(data => {
          if(isLocalStorageSupported()) {
            localStorage.setItem(`survey-taken-${surveyId}`, true);
          }
          dispatch(submitSurveySuccess(data));
          return data;
        })
        .catch(error => {
          APIUtils.parseJSON(error).then(data => {
            dispatch(submitSurveyError(APIUtils.parseError(data)));
          })
        })
    }

  };
}

export function switchToSurveyPage(position, eventId, surveyId) {
  return (dispatch, getState) => {
    const surveyPages = getState().surveyPages;
    const currentPagePosition = getState().currentPage;
    const switchingToNextPage = position > currentPagePosition;
    let currentPageValid = true;
    // first check if current page is valid
    if(switchingToNextPage) {
      let currentSurveyResponse = find(getState().surveyResponses, { 'surveyPagePosition': currentPagePosition });
      currentPageValid = checkIfQuestionsAreValid(currentSurveyResponse.questionResponses);
    }

    if(!currentPageValid) {
      return dispatch(currentPageNotValid());
    } else {
      let pageExists = find(surveyPages, { 'position': position });

      if(pageExists !== undefined) {
        return dispatch(changeCurrentSurveyPageToValue(position));
      } else {
        return dispatch(fetchSurveyPage(eventId, surveyId, position));
      }
    }

  };
}

export function changeCurrentSurveyPageToValue(value) {
  return {
    type: Actions.CHANGE_CURRENT_SURVEY_PAGE_TO_VALUE,
    value: value
  };
}

export function fetchSurveyPage(eventId, surveyId, position) {
  return function(dispatch) {
    dispatch(fetchSurveyPageBegin());
    let url = `/api/public/events/${eventId}/surveys/${surveyId}/survey_pages?position=${position}&metadata=true`
    return fetch(url, {headers: defaultHeaderOptions})
      .then(APIUtils.checkStatus)
      .then(APIUtils.parseJSON)
      .then(data => {
        dispatch(fetchSurveyPageSuccess(data));
        return data;
      })
      .catch(error => dispatch(fetchSurveyPageError(error)));
  };
}

export function fetchSurveyPageBegin() {
  return {
    type: Actions.FETCH_SURVEY_PAGE_BEGIN
  };
}

export function fetchSurveyPageSuccess(data) {
  return {
    type: Actions.FETCH_SURVEY_PAGE_SUCCESS,
    payload: data
  };
}

export function fetchSurveyPageError(error) {
  return {
    type: Actions.FETCH_SURVEY_PAGE_ERROR,
    error: error
  };
}

export function submitSurveyBegin() {
  return {
    type: Actions.SUBMIT_SURVEY_BEGIN
  };
}

export function submitSurveySuccess(data) {
  return {
    type: Actions.SUBMIT_SURVEY_SUCCESS,
    payload: data
  };
}

export function submitSurveyError(error) {
  return {
    type: Actions.SUBMIT_SURVEY_ERROR,
    error: error
  };
}

export function currentPageNotValid() {
  return {
    type: Actions.CURRENT_PAGE_NOT_VALID
  };
}

export function handleQuestionResponseChange(questionData, value, typeOfResponse) {
  return {
    type: Actions.HANDLE_QUESTION_RESPONSE_CHANGE,
    payload: questionData,
    value: value,
    typeOfResponse: typeOfResponse
  };
}

export function addAnswerIdsToQuestionResponse(questionData, value, typeOfResponse) {
  return {
    type: Actions.ADD_ANSWER_IDS_TO_QUESTION_RESPONSE,
    payload: questionData,
    value: value,
    typeOfResponse: typeOfResponse
  };
}

export function removeAnswerIdsToQuestionResponse(questionData, value, typeOfResponse) {
  return {
    type: Actions.REMOVE_ANSWER_IDS_TO_QUESTION_RESPONSE,
    payload: questionData,
    value: value,
    typeOfResponse: typeOfResponse
  };
}

